import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, LoadingController, ModalController, AlertController} from 'ionic-angular';
import { RcsKdDataServiceProvider } from '../../providers/rcs-kd-data-service/rcs-kd-data-service';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { OrderlinePrototyp } from '../../assets/shared/orderline.object';
import { RcsModalWorkline } from '../../components/rcs-modal-workline/rcs-modal-workline';
import { DraftServiceProvider } from '../../providers/draft-service/draft-service';
import { JobCommitProvider } from '../../providers/job-commit/job-commit';
import {RcsConnectorIndexDbProvider} from "../../providers/rcs-connector-index-db/rcs-connector-index-db";

@IonicPage()
@Component({
  selector: 'page-job',
  templateUrl: 'job.html',
})
export class JobPage implements OnInit, AfterViewInit{

  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  public job;
  public user: any
  public design_job;
  public design_job_date: Date
  //private page_type: string = 'normal';
  private job_type: string;
  private page: string;
  private loading: Loading;
  //private monteur_id: string;
  private signaturePadOptions: Object

  constructor(public navCtrl: NavController,
              public nav_params: NavParams,
              public loadingCtrl: LoadingController,
              public dataService: RcsKdDataServiceProvider,
              private draft_service: DraftServiceProvider,
              private modal_controller: ModalController,
              private job_commit: JobCommitProvider,
              private db: RcsConnectorIndexDbProvider,
              private alert_controller: AlertController,
  ) {
    this.signaturePadOptions = {
      'canvasWidth': 550,
      'canvasHeight': 550
    };
  }

  ngOnInit():void{
    this.job = this.nav_params.get('job');
    if (!this.job) {
      this.navCtrl.setRoot('HomePage')
    } else {
      if (this.job.finish_notes === 'false') {
        this.job.finish_notes = '';
      }
    
      this.get_job_type();
      this.page = this.nav_params.get('page');
      this.validate_job();
      //this.monteur_id = this.job.monteur_id[0];
      this.db.search_by_key('login', 'user_login').subscribe(user => {
        this.user = user
      })
      this.draft_service.get_draft(this.job).subscribe(
        design => {
          let job_timestamp = new Date(this.job.write_date).getTime();
          let draft_timestamp = new Date(design.write_date).getTime();
          if (job_timestamp > draft_timestamp && this.job.state_name !== 'erledigt'){
            this.design_job = design;
            let timestamp = new Date(design.write_date)
            timestamp.setHours(timestamp.getHours()+1);
            this.design_job_date = timestamp;
          }
        }
      );
    }
  }

  ngAfterViewInit() {
    if (this.job && this.job.signature){
      let decoded_image = "data:image/png;base64," + this.job.signature;
      this.signaturePad.fromDataURL(decoded_image);
    }
  }

  private validate_job(){
      if (this.job && this.job.finish_notes == false){
          this.job.finish_notes = '';
      }
  }

  public isJobBeginnenVisible() {
    return (localStorage.getItem('manual_sync_needed') === null);
  }

  public load_job_design(){
    this.job = this.design_job;
    this.design_job = false;
  }

  public delete_job_design(){
    this.design_job = false;
    this.draft_service.delete(this.job.id, 4);
  }
  // FINISHLINE-----------------------------------------------------------------

  public add_finishline(){
      let prototyp = new OrderlinePrototyp();
      prototyp.id = Math.random();
      prototyp.product_id = [0, null];
      prototyp.product_uom = [34, null];
      prototyp.route = [0, null];
      prototyp.qty_real = 0;
      prototyp.state = 'new';
      prototyp.state_app = 'new';
      prototyp.create_uid = [this.user.uid, this.job.monteur_id[1]];

      this.navCtrl.push('JobImplementationPage', {'finishline': prototyp, 'job_mode': 'execution', job: this.job})
  }

  // Speichert Änderungen im Job
  public edit_finishline(finishline:any){
      this.navCtrl.push('JobImplementationPage', {'finishline': finishline, 'job_mode': 'execution', job: this.job})
  }

  // Entfernt eine Orderline aus der lokalen Datenbank und sendet einen Task an das Odoo
  public delete_finishline(finishline){
      let keys = Object.keys(this.job.orderline);
      for(let key of keys){
          if (this.job.orderline[key].id == finishline.id){
            this.job.orderline[key].state = 'delete';
            break;
          }
      }
  }

  // Workline-------------------------------------------------------------------

  // Fügt eine Workline zum Job hinzu
  public add_workline(){
      let modal_workline_page = this.modal_controller.create(
          RcsModalWorkline, {}, { enableBackdropDismiss: false } 
      );

      modal_workline_page.present();

      setTimeout(() => {
        modal_workline_page.onDidDismiss(
          (data) => {
              if (data){
                  let workline = data.workline;
                  workline.id = Math.random();
                  workline.monteur_id = this.job.monteur_id;
                  workline.state = 'new';
                  workline.state_app = 'new';
                  this.job.workline.push(workline);
              }
          }
        )
      }, 500);
  }

  // Speichert Änderungen im Job
  public edit_workline(workline:any){
      let modal_workline_page = this.modal_controller.create(
          RcsModalWorkline, { workline: workline }, { enableBackdropDismiss: false }
      );

      modal_workline_page.present();
      
      setTimeout(() => {
          modal_workline_page.onDidDismiss(
            (data) => {
              console.log(data);
              if (data){
                  let workline = data.workline;
                  workline.monteur_id = [this.job.monteur_id[0], null];
                  for (let item of this.job.workline){
                      if (item.id == workline.id){ item = workline }
                  }
              } else {
                modal_workline_page = null;
              }
            }
        )
      }, 500);
  }

  // Entfernt eine Workline aus der lokalen Datenbank und sendet einen Task an das Odoo
  public delete_workline(workline){
    let keys = Object.keys(this.job.workline);
    for(let key of keys){
      console.info("DELETE", this.job.workline[key], workline, this.job.workline[key] == workline);
      if (this.job.workline[key].id == workline.id){
        setTimeout(() => {
          console.info(this.job.workline[key]);
          this.job.workline[key].state = 'delete';
        }, 500);
        break;
      }
    };
  }

  public drawComplete() {
    if (this.signaturePad.isEmpty()){
      this.job.signature = false;
    }else{
      let data_url = this.signaturePad.toDataURL();
      this.job.signature = data_url.split(",")[1];
    }
  }

  public drawStart() {}

  public clear_signature(){
    this.signaturePad.clear();
    this.job.signature = false;
  }

  private showLoading(message: string):void {
    this.loading = this.loadingCtrl.create({
      content: message,
      dismissOnPageChange: true
    });
    this.loading.present();
  }

  public get_job_type(){
    if (!this.job || this.job.state_name === 'erledigt' || this.job.state_name === 'Kontrolle'){
      this.job_type = 'finish';
    } else if (this.job.state_name === 'in Arbeit'){
      this.job_type = 'work';
    }else{
      this.job_type = 'details';
    }
  }

  private validate_job_for_save(job){
    job.orderline = job.orderline.filter(element => {
      return element.state_app !== 'delete' && element.product_id !== false && element.product_id[0] !== 0;
    })
    return job;
  }

  public save_job():void{
    this.showLoading('Job wird gespeichert');
    let valid_job = this.validate_job_for_save(this.job);
    this.job_commit.save(valid_job).subscribe((job) => {
      console.log("AAAA", job);
      this.job = job;
      setTimeout(() => {
        this.loading.dismiss();
      }, 1500);
    }, () => {
      this.loading.dismiss();
      //alert('Beim Speichern des Auftrages ist zu einem Fehler gekommen');
    })
  }

  public start_job(job:any){
    this.showLoading('Job wird als begonnen markiert');
    job.state_name = 'in Arbeit';
    this.job_type = 'work';
    this.job_commit.signal_job_start(job).subscribe((updated_job) => {
        this.job = updated_job;
        setTimeout(() => {
          this.loading.dismiss();
        }, 500);
      }, () => {
        this.loading.dismiss();
      })
  }

  /** public start_job(job:any){
    this.showLoading('Job wird als begonnen markiert');
    this.job_type = 'work';
    this.job_commit.signal_job_start(job).subscribe(() => {
      this.loading.dismiss();
      this.job = job
    }, () => {
      this.loading.dismiss();
      alert('Beim Ändern des Status kam es zu einem Fehler')
    })
  }*/

  public finish_job(job:any){
    this.showLoading('Job wird gespeichert und als beendet markiert');
    let valid_job = this.validate_job_for_save(job);
    valid_job.state_name = 'Kontrolle';
    this.job_commit.save(valid_job).subscribe(() => {
      this.job_type = 'finish';
      this.job_commit.signal_job_finish(job).subscribe((job) => {
        this.job = job;
        setTimeout(() => {
          this.loading.dismiss();
        }, 500);
      }, () => {
        this.job = job;
        this.loading.dismiss();        
      })
    }, () => {
      this.job_type = 'finish';
      this.job_commit.signal_job_finish(job).subscribe((job) => {
          this.job = job;
          setTimeout(() => {
            this.loading.dismiss();
          }, 500);
        }, () => {
          this.job = job;
          this.loading.dismiss();
      })
    })
  }

  public abort_job():void{
    let alert = this.alert_controller.create({
      title: 'Wollen Sie wirklich abbrechen?',
      subTitle: 'Alle Änderungen gehen verloren.',
      buttons: [
        {
          text: 'Ja',
          handler: () => {
            this.navCtrl.pop();
          },
        },
        {
          text: 'Nein',
          role: 'cancel',
        }
      ]
    });
    alert.present();    
  }
}



// WEBPACK FOOTER //
// ./src/pages/job/job.ts